import { ErrorBoundary } from "@sentry/react";
import React from "react";
import { ErrorMsg } from "../../components/AppMessages";
import { IframeLayout } from "../../components/Layouts";
import { IframePageContentComingSoon } from "../../components/PageContent";

// /beta/cxo_experiment (menu item "CXO Experiment Library", DASHBOARD_REGISTRY key
// cxo_experiment_library) had no route registered at all - a real, pre-existing 404, confirmed
// live and unrelated to the PrivateRoute registry flip. IframePageContentComingSoon already exists
// for exactly this "menu item exists, page doesn't yet" case; this is its first real call site.
const CxoExperimentLibrary = () => (
  <IframeLayout hasFilter={false}>
    <ErrorBoundary fallback={<ErrorMsg />}>
      <IframePageContentComingSoon iframeUrl="" frameId="cxo_experiment_library" />
    </ErrorBoundary>
  </IframeLayout>
);

export default CxoExperimentLibrary;
